
import axiosInstance from "."; // Assuming this is your configured axios instance

// Interface for type safety
interface ContactBody {
  name: string;
  phone: string;
  category: string;
  message: string;
}

// Create a new contact request
export const createContactAPI = async ({ body }: { body: ContactBody }) => {
  const response = await axiosInstance.post(`/contact`, body);
  return response;
};

// Get all contact requests
export const getAllContactsAPI = async () => {
  const response = await axiosInstance.get(`/contact/contacts`);
  return response;
};

// Get a single contact request by ID
export const getContactByIdAPI = async ({ id }: { id: string }) => {
  const response = await axiosInstance.get(`/contact/${id}`);
  return response;
};

// Delete a contact request
export const deleteContactAPI = async ({ id }: { id: string }) => {
  const response = await axiosInstance.delete(`/contact/contact/${id}`);
  return response;
};
